import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Breadcrumbs, Link, Typography } from '@mui/material';
import { NavigateNext } from '@mui/icons-material';

export interface Crumb {
  label: string;
  to?: string;
}

/** Trail above a detail page title; the last crumb is the current page. */
export const PageBreadcrumbs: React.FC<{ items: Crumb[] }> = ({ items }) => (
  <Breadcrumbs separator={<NavigateNext sx={{ fontSize: 16 }} />} sx={{ mb: 0.5, '& .MuiBreadcrumbs-ol': { flexWrap: 'nowrap' } }}>
    {items.map((c, i) =>
      c.to && i < items.length - 1 ? (
        <Link key={i} component={RouterLink} to={c.to} underline="hover" color="text.secondary" variant="body2" noWrap>
          {c.label}
        </Link>
      ) : (
        <Typography key={i} variant="body2" color="text.primary" noWrap sx={{ maxWidth: 360 }}>
          {c.label}
        </Typography>
      ),
    )}
  </Breadcrumbs>
);
